var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTeam = function SvgTeam(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M9.667 6.666a.333.333 0 1 1 .666 0 .333.333 0 0 1-.666 0ZM10 4.333A2.333 2.333 0 1 0 10 9a2.333 2.333 0 0 0 0-4.667ZM9 18.431v-4.377l-7.316-2.438a1 1 0 0 1 .632-1.898L10 12.28l7.684-2.562a1 1 0 0 1 .632 1.898L11 14.054v4.377l3.895 7.789a1 1 0 0 1-1.79.894L10 20.904l-3.106 6.21a1 1 0 1 1-1.788-.894L9 18.43Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M23.5 11.75a.25.25 0 1 1 .5 0 .25.25 0 0 1-.5 0Zm.25-1.75a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5ZM23 20.574v-3.283l-5.487-1.829a.75.75 0 0 1 .474-1.423l5.763 1.92 5.763-1.92a.75.75 0 0 1 .474 1.423l-5.487 1.83v3.28l2.921 5.843a.75.75 0 1 1-1.342.67l-2.329-4.658-2.329 4.659a.75.75 0 1 1-1.342-.671l2.92-5.84Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTeam);
export default ForwardRef;